import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import ReactGA from 'react-ga4';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ErrorContextProvider } from './store/errorContext';
import { SDKWrapper } from './helpers/sdkWrapper';
import { isErudaConsole } from './helpers/config';
import eruda from 'eruda';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <ErrorContextProvider>
            <QueryClientProvider client={queryClient}>
                <SDKWrapper>
                    <App />
                    <ToastContainer />
                </SDKWrapper>
            </QueryClientProvider>
        </ErrorContextProvider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (isErudaConsole()) {
    eruda.init();
}

if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
}
